export default {
  primary: {
    main: "#643d74",
  },
  secondary: {
    main: "#bba9c3",
    contrastText: "#fff",
  }
}
